import React from "react";
import { Row, Col, Spin } from "antd";
import Text from "../Text/Text";

interface ProgressNotificationProps {
  progress: number;
  fileSize?: string;
  label: string;
}

const ProgressNotification: React.FC<ProgressNotificationProps> = ({
  progress,
  fileSize,
  label,
}) => {
  const isSpinnerPhase = progress < 70;

  return (
    <Row style={{ display: "flex", alignItems: "center", width: "100%" }}>
      <Col
        span={2}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginRight: "16px",
        }}
      >
        {isSpinnerPhase ? <Spin size='large' /> : <Spin percent={progress} size='large' />}
      </Col>
      <Col span={20}>
        <Text fontSize={16} fontWeight={700}>
          {label}
        </Text>
        {fileSize ? (
          <>
            <br />
            <Text fontSize={14} fontWeight={400} color='grayishBlue'>
              ไฟล์ขนาด {fileSize}
            </Text>
          </>
        ) : null}
      </Col>
    </Row>
  );
};

export default ProgressNotification;
